export default __webpack_public_path__ + "static/media/BrainBreak cards95.a84b9bda.png";